import classNames from "classnames";
import { GatsbyImage, IGatsbyImageData } from "gatsby-plugin-image";
import React from "react";
import { ArrowCircleIcon } from "../icons/ArrowCircleIcon";

export const PersonCTA: React.FC<{
  image?: IGatsbyImageData | null;
  name?: string | null;
  jobTitle?: string | null;
  email?: string | null;
  phone?: string | null;
  index: number;
}> = ({ image, name, jobTitle, email, phone, index }) => {
  return (
    <div
      data-component="Person CTA"
      className={classNames(
        "bg-hyacinth text-lazer",
        "relative grid gap-x-mobile px-mobile",
        "grid-cols-4 py-60px md:grid-cols-6 md:gap-x-tablet lg:m-0 lg:gap-x-desktop"
      )}
    >
      {image && (
        <div
          className={classNames(
            "aspect-h-1 aspect-w-1",
            "col-span-1 col-start-1 md:col-span-2 md:col-start-1 lg:col-span-1 lg:col-start-2",
            "row-span-3 row-start-1"
          )}
        >
          <GatsbyImage
            image={image}
            alt={name ?? "Individual"}
            style={{ position: "absolute" }}
            objectFit="contain"
            objectPosition="center"
            className="rounded-full"
            loading="lazy"
          />
        </div>
      )}
      {name && (
        <h3 className="h6 col-span-3 col-start-2 row-start-1 md:col-span-4 md:col-start-3 lg:col-span-3 lg:col-start-3">
          {name}
        </h3>
      )}
      {jobTitle && (
        <h4 className="p4 col-span-3 col-start-2 row-start-2 md:col-span-4 md:col-start-3 lg:col-span-3 lg:col-start-3">
          {jobTitle}
        </h4>
      )}
      {email && (
        <a
          aria-label="Send e-mail"
          href={`mailto:${email}`}
          className="p4 col-span-3 col-start-2 row-start-4 pt-10px md:col-span-4 md:col-start-3 lg:col-span-3 lg:col-start-3"
        >
          {email}
        </a>
      )}
      {phone && (
        <p className="p4 col-span-3 col-start-2 row-start-5 md:col-span-4 md:col-start-3 lg:col-span-3 lg:col-start-3">
          {phone}
        </p>
      )}
      {email && (
        <a
          className="col-span-1 col-start-4 row-span-2 row-start-4 self-end justify-self-start md:col-span-1 md:col-start-6"
          href={`mailto:${email}`}
          aria-label="Send e-mail"
        >
          <ArrowCircleIcon
            aria-hiden="true"
            className="h-38px -rotate-135 transform-gpu"
          />
        </a>
      )}
      <div
        className={classNames(
          "absolute bottom-0 left-0 right-0 block h-2px bg-dashed",
          index % 2 === 1 && "md:hidden",
          "md:left-auto md:top-0 md:h-full md:w-2px md:bg-dashedY"
        )}
      />
    </div>
  );
};
